export default __webpack_public_path__ + "static/media/ic-plus-a.d69e6aa2.svg";